module.exports = __webpack_public_path__ + "dist/media/icons-social.ecbc3e33.svg";